import { forwardRef } from "react";

import { DisplayState } from "@/constants/state";
import {
  ICON_BUTTON_DEFAULTS,
  ICON_BUTTON_SIZE_CLASS_MAP,
  ICON_BUTTON_VARIANT_CLASS_MAP,
  type TIconButtonProps,
} from "@/ui/components/primitives/IconButton";
import { Icon } from "@/ui/components/primitives/Icon";
import { Spinner } from "@/ui/components/primitives/Spinner";
import { cn } from "@/ui/lib/utils";

export const IconButton = forwardRef<HTMLButtonElement, TIconButtonProps>(
  (
    {
      className,
      icon,
      size = ICON_BUTTON_DEFAULTS.size,
      state,
      type = "button",
      variant = ICON_BUTTON_DEFAULTS.variant,
      ...props
    },
    ref,
  ) => (
    <button
      {...props}
      ref={ref}
      type={type}
      data-component="IconButton"
      className={cn(
        "inline-flex shrink-0 items-center justify-center",
        "rounded-sys-md",
        "border-solid",
        "transition-all duration-200",
        "focus-visible:outline-none focus-visible:ring-2",
        "disabled:pointer-events-none disabled:opacity-50",
        "[&_svg]:pointer-events-none [&_svg]:shrink-0",
        ICON_BUTTON_VARIANT_CLASS_MAP[variant],
        ICON_BUTTON_SIZE_CLASS_MAP[size],
        className,
      )}
      disabled={state === DisplayState.LOADING || props.disabled}
    >
      { state === DisplayState.LOADING ? (
        <Spinner />
      ) : (
        <Icon icon={icon} aria-hidden="true" />
      ) }
    </button>
  ),
);

IconButton.displayName = "IconButton";
